import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function AudioType(): React.ReactElement {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#audio_type)">
        <path d="M18 0.000732422C8.06353 0.012108 0.0113755 8.06426 0 18.0007V32.1435C0 34.2738 1.7269 36.0007 3.85714 36.0007H9.00002C9.71012 36.0007 10.2858 35.425 10.2858 34.7149V21.8578C10.2858 21.1477 9.71012 20.5721 9.00002 20.5721H3.85714C3.41809 20.5768 2.98311 20.6572 2.5714 20.8099V18.0006C2.5714 9.47965 9.479 2.57206 18 2.57206C26.5209 2.57206 33.4285 9.47965 33.4285 18.0006V20.8099C33.0168 20.6572 32.5818 20.5768 32.1428 20.5721H27C26.2899 20.5721 25.7142 21.1477 25.7142 21.8578V34.715C25.7142 35.4251 26.2899 36.0007 27 36.0007H32.1429C34.2731 36.0007 36 34.2738 36 32.1436V18.0007C35.9886 8.06426 27.9364 0.012108 18 0.000732422Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="audio_type">
          <rect width="36" height="36" fill="white" transform="translate(0 0.000732422)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
